/**
 * Sentinel option ID for the ebook bundle in the product options dropdown.
 * When selected, triggers AddEbookBundleToShoppingCart instead of AddItemToShoppingCart.
 */
export const EBOOK_BUNDLE_SENTINEL = -1;
